export default {
  country_locale: 'ro-RO',
  wia_title: 'Să începem cu produsul:',
  wia_need_help: 'Am nevoie de ajutor pentru',
  wia_model_name: 'Numele produsului este',
  wia_back: '< modificare',
  wia_confirm: 'Trimite',
  wia_issue_title: 'Ce problemă ai întâmpinat?',
  wia_issue_concern: 'Ce problemă ai întâmpinat?',
  wia_issue_specific: 'Câteva detalii suplimentare',
  wia_possible_solution: 'Posibile soluţii',
  wia_solved_issue: 'S-a rezolvat problema?',
  wia_closed: 'Închidere X',
  wia_feedback_ok: ' Da!',
  wia_find_another_solution: 'Găsește altă soluţie',
  wia_feedback_title: 'Ne bucurăm că problema ta s-a rezolvat!',
  wia_feedback_text1: 'Te invităm să vizitezi magazinul noastru online pentru a descoperi ofertele disponibile',
  wia_feedback_text2: '',
  wia_smile_up_popup_text1: 'Descoperiți planul nostru de garanție',
  wia_smile_down_popup_title: 'Ai nevoie de mai mult ajutor?',
  wia_smile_down_popup_text1: 'Treceți la pasul al doilea',
  wia_smile_down_popup_or_text: 'ori',
  wia_smile_down_popup_text2: 'Rezervă o întâlnire',
  wia_need_more_help: 'Ai nevoie de mai mult ajutor?',
  wia_optional_label: '(opţional)',
  wia_no_solution: 'Din păcate, nu există soluții de self-service pentru problema ta. Te rugăm să faceți click aici pentru asistență suplimentară.',
  wia_all_solution: 'Toate rezultatele',
  wia_all_categories: 'Toate categoriile',
  wia_seo_l1_issue: 'Toate problemele sortate pe categorii',
  wia_seo_wp_country_name: 'Romania',
  wia_seo_bk_country_name: '',
  wia_seo_hp_country_name: 'RO',
  wia_seo_id_country_name: 'RO',
  wia_seo_wp_meta_title: 'Probleme și Soluții',
  wia_seo_bk_meta_title: 'Probleme și Soluții',
  wia_seo_hp_meta_title: 'Probleme și Soluții',
  wia_seo_id_meta_title: 'Probleme și Soluții',
  wia_seo_wp_meta_description: 'Rezolvă problemele legate de produsele tale, cu doar câteva click-uri, prin intermediul asistenței tehnice online de la European Appliances Romania SRL',
  wia_seo_bk_meta_description: 'Rezolvă problemele legate de produsele tale, cu doar câteva click-uri, prin intermediul asistenței tehnice online de la Bauknecht Romania',
  wia_seo_hp_meta_description: 'Rezolvă problemele legate de produsele tale, cu doar câteva click-uri, prin intermediul asistenței tehnice online de la Hotpoint Romania',
  wia_seo_id_meta_description: 'Rezolvă problemele legate de produsele tale, cu doar câteva click-uri, prin intermediul asistenței tehnice online de la Indesit Romania',
  wia_seo_wp_meta_description_home: '',
  wia_seo_bk_meta_description_home: '',
  wia_seo_hp_meta_description_home: '',
  wia_seo_id_meta_description_home: ''
}
